<template lang="pug">

  .lesson-block__content.lesson-test-preview(v-if="content.preview")
    .lesson-test-preview__info
      .lesson-test-preview__title
        | {{content.preview.title}}
      .lesson-test-preview__description.form-item__markdown(
        v-html="makeHtml(content.preview.description)"
      )
    .lesson-test-preview__img(
      :style="{backgroundImage: `url('${content.preview.img.url}')`}"
    )
    Button.-xs-.lesson-test-preview__button(
      @click="showAdminMessage"
    )
      | Начать


</template>

<script>
import markdownToHtml from '@/functions/converterMarkdownToHtml';

export default {
  props: ['content'],
  methods: {
    showAdminMessage() {
      this.$store.dispatch(
        'ajax/addMessage',
        { message: 'В режиме администратора не работает', type: 'success' },
        { root: true }
      );
    },
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    }
  }
};
</script>
